<template>
    <div>
        <div class="pt-2 mx-8">
            <div class="collapse bg-base-100 mb-2" v-if="detailData.running.length > 0">
                <input type="checkbox" v-model="isRunning"/>
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('进行中') }}</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.running_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>{{ $tt('文件名') }}</th>
                                <th>{{ $tt('创建时间') }}</th>
                                <th>{{ $tt('原因') }}</th>
                                <th>{{ $tt('操作') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in detailData.running" :key="'running' + index">
                                <th>{{ index + 1 }}</th>
                                <td>{{ item.name }}</td>
                                <td>{{ item.created_at }}</td>
                                <td>{{ item.reason }}</td>
                                <td>
                                    <button class="btn btn-xs btn-outline btn-error" @click="handleStopDetail(item.id)">{{ $tt('停止') }}</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="collapse bg-base-100 mb-2" v-if="detailData.success.length > 0">
                <input type="checkbox" v-model="isSuccess" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('元数据扫描') }}</div>
                        <div class="badge badge-success gap-2 ml-2">
                            {{detailData.success_count}}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>{{ $tt('文件名') }}</th>
                                <th>{{ $tt('文件路径') }}</th>
                                <th class="w-32">{{ $tt('原因') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in detailData.success" :key="'mode' + index">
                                <th>{{index + 1}}</th>
                                <td>{{item.name}}</td>
                                <td>{{item.path}}</td>
                                <td>{{ $tt('读取元数据') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="collapse bg-base-100 mb-2" v-if="detailData.mode_success.length > 0">
                <input type="checkbox" v-model="isModeSuccess" />
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('音乐收藏') }}</div>
                        <div class="badge badge-success gap-2 ml-2">
                            {{detailData.mode_success_count}}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{{ $tt('文件名') }}</th>
                                    <th>{{ $tt('文件路径') }}</th>
                                    <th class="w-32">{{ $tt('原因') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- row 1 -->
                                <tr v-for="(item, index) in detailData.mode_success" :key="'mode' + index">
                                    <th>{{index + 1}}</th>
                                    <td>{{item.name}}</td>
                                    <td>{{item.path}}</td>
                                    <td>{{item.reason}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="collapse bg-base-100 mb-2" v-if="detailData.fail.length > 0">
                <input type="checkbox" v-model="isFail"/>
                <div class="collapse-title text-xl font-medium">
                    <div class="flex items-center">
                        <div>{{ $tt('异常失败') }}</div>
                        <div class="badge badge-error gap-2 ml-2">
                            {{ detailData.fail_count }}
                        </div>
                    </div>
                </div>
                <div class="collapse-content">
                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>{{ $tt('文件路径') }}</th>
                                <th>{{ $tt('原因') }}</th>
                                <th>{{ $tt('操作') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.fail" :key="'fail' + index">
                                <th>{{ (pagination.fail.current - 1) * pagination.fail.pageSize + index + 1 }}</th>
                                <td>{{ item.path }}</td>
                                <td>{{ item.reason }}</td>
                                <td>
                                    <a class="link link-secondary" v-if="item.candidate_list.length >0"
                                       @click="handleBeixuan(item)">{{ $tt('候选') }}</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.fail && detailData.fail.length > pagination.fail.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.fail.current === 1}"
                                    @click="handlePageChange('fail', pagination.fail.current - 1)">«</button>
                                <button class="join-item btn btn-sm">{{ $tt('第 {page} 页', { page: pagination.fail.current }) }}</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.fail || pagination.fail.current >= Math.ceil(detailData.fail.length / pagination.fail.pageSize)}"
                                    @click="handlePageChange('fail', pagination.fail.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bg-base-100 mb-2" v-if="detailData.false_file && detailData.false_file.length > 0">
                <div class="card-body">
                    <div class="flex items-center justify-between mb-4">
                        <div class="flex items-center">
                            <div class="text-xl font-medium">{{ $tt('虚假文件格式') }}</div>
                            <div class="badge badge-warning gap-2 ml-2">
                                {{ detailData.false_file_count || detailData.false_file.length }}
                            </div>
                        </div>

                        <button class="btn btn-sm btn-primary ml-4" @click="handleFixFalseFile" :disabled="isFixingFalseFile">
                            <span v-if="isFixingFalseFile" class="loading loading-spinner loading-xs"></span>
                            {{ isFixingFalseFile ? $tt('修复中...') : $tt('批量修复后缀名') }}
                        </button>
                    </div>

                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>{{ $tt('文件路径') }}</th>
                                <th>{{ $tt('原因') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.false_file" :key="'false_file' + index">
                                <th>{{ (pagination.false_file.current - 1) * pagination.false_file.pageSize + index + 1 }}</th>
                                <td>{{ item.path }}</td>
                                <td>{{ item.reason }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.false_file && detailData.false_file.length > pagination.false_file.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.false_file.current === 1}"
                                    @click="handlePageChange('false_file', pagination.false_file.current - 1)">«</button>
                                <button class="join-item btn btn-sm">{{ $tt('第 {page} 页', { page: pagination.false_file.current }) }}</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.false_file || pagination.false_file.current >= Math.ceil(detailData.false_file.length / pagination.false_file.pageSize)}"
                                    @click="handlePageChange('false_file', pagination.false_file.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bg-base-100 mb-2" v-if="detailData.metadata_error && detailData.metadata_error.length > 0">
                <div class="card-body">
                    <div class="flex items-center justify-between mb-4">
                        <div class="flex items-center">
                            <div class="text-xl font-medium">{{ $tt('元数据错误') }}</div>
                            <div class="badge badge-error gap-2 ml-2">
                                {{ detailData.metadata_error_count || detailData.metadata_error.length }}
                            </div>
                        </div>

                        <button class="btn btn-sm btn-primary ml-4" @click="handleFixMetadataError" :disabled="isFixingMetadataError">
                            <span v-if="isFixingMetadataError" class="loading loading-spinner loading-xs"></span>
                            {{ isFixingMetadataError ? $tt('修复中...') : $tt('批量修复元数据') }}
                        </button>
                    </div>

                    <div class="overflow-x-auto">
                        <table class="table table-zebra">
                            <!-- head -->
                            <thead>
                            <tr>
                                <th></th>
                                <th>{{ $tt('文件路径') }}</th>
                                <th>{{ $tt('原因') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <!-- row 1 -->
                            <tr v-for="(item, index) in paginatedData.metadata_error" :key="'metadata_error' + index">
                                <th>{{ (pagination.metadata_error.current - 1) * pagination.metadata_error.pageSize + index + 1 }}</th>
                                <td>{{ item.path }}</td>
                                <td>{{ item.reason }}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center mt-4" v-if="detailData.metadata_error && detailData.metadata_error.length > pagination.metadata_error.pageSize">
                            <div class="join">
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': pagination.metadata_error.current === 1}"
                                    @click="handlePageChange('metadata_error', pagination.metadata_error.current - 1)">«</button>
                                <button class="join-item btn btn-sm">{{ $tt('第 {page} 页', { page: pagination.metadata_error.current }) }}</button>
                                <button class="join-item btn btn-sm"
                                    :class="{'btn-disabled': !detailData.metadata_error || pagination.metadata_error.current >= Math.ceil(detailData.metadata_error.length / pagination.metadata_error.pageSize)}"
                                    @click="handlePageChange('metadata_error', pagination.metadata_error.current + 1)">»</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'log-detail',
        props: {
            detailData: { type: Object, required: true }
        },
        data() {
            return {
                id: this.$route.params.id,
                isOpen: true,
                timer: null,
                isFixingFalseFile: false,
                isFixingMetadataError: false,
                pagination: {
                    fail: { current: 1, pageSize: 10 },
                    false_file: { current: 1, pageSize: 10 },
                    metadata_error: { current: 1, pageSize: 10 }
                }
            }
        },
        computed: {
            paginatedData() {
                return {
                    fail: this.getPaginatedData(this.detailData.fail || [], this.pagination.fail),
                    false_file: this.getPaginatedData(this.detailData.false_file || [], this.pagination.false_file),
                    metadata_error: this.getPaginatedData(this.detailData.metadata_error || [], this.pagination.metadata_error)
                }
            },
            isSuccess() {
                return this.detailData.success.length > 0
            },
            isFail() {
                return this.detailData.fail.length > 0
            },
            isModeSuccess() {
                return this.detailData.mode_success.length > 0
            },
            isMissAA() {
                return this.detailData.miss_artist_album.length > 0
            },
            isMissArtist() {
                return this.detailData.miss_artist.length > 0
            },
            isMissAlbum() {
                return this.detailData.miss_album.length > 0
            },
            isMissTag() {
                return this.detailData.miss_tag.length > 0
            },
            isRunning() {
                return this.detailData.running.length > 0
            },
            isSkip() {
                return this.detailData.skip.length > 0
            },
            isFalseFile() {
                return this.detailData.false_file && this.detailData.false_file.length > 0
            },
            isMetadataError() {
                return this.detailData.metadata_error && this.detailData.metadata_error.length > 0
            }
        },
        mounted() {
            // this.handlePolling()
        },
        beforeDestroy() {
            // this.setTimerNull() // 组件销毁前清空定时器
        },
        methods: {
            getPaginatedData(data, pagination) {
                const start = (pagination.current - 1) * pagination.pageSize;
                const end = start + pagination.pageSize;
                return data.slice(start, end);
            },
            handlePageChange(type, page) {
                this.pagination[type].current = page;
            },
            handleRemoveFile(path, mode) {
                this.$bkInfo({
                    title: this.$tt('确认要删除文件？'),
                    confirmLoading: true,
                    confirmFn: () => {
                        try {
                            this.isLoading = true
                            this.$api.Task.deleteFiles(
                                {
                                    'log_id': this.id,
                                    'paths': [path],
                                    'mode': mode
                                }).then((res) => {
                                this.isLoading = false
                                if (res.result) {
                                    this.$myMsg.notify({
                            title: this.$tt('删除成功！'),
                            type: 'success',
                            time: 2000,
                        })
                                    this.$parent.fetchDetails()
                                } else {
                                    this.$myMsg.notify({
                                        title: this.$tt('删除失败！'),
                                        content: res.message || this.$tt('删除失败'),
                                        type: 'error',
                                        time: 2000,
                                    })
                                }
                            })
                            return true
                        } catch (e) {
                            console.warn(e)
                            return false
                        }
                    }
                })
            },
            handleFixFalseFile() {

                try {
                    this.isFixingFalseFile = true
                    this.$api.Task.queryDetailsByStatus({
                        log_id: this.id,
                        status: 'false_file'
                    }).then((res) => {
                        this.isFixingFalseFile = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: this.$tt('修复任务已提交！'),
                                content: this.$tt('找到 {count} 个文件，后台正在处理中，请稍后查看审计日志', { count: res.data.count }),
                                type: 'success',
                                time: 3000,
                            })
                            // 3秒后刷新详情
                            setTimeout(() => {
                                this.$parent.fetchDetails()
                            }, 3000)
                        } else {
                            this.$myMsg.notify({
                                title: this.$tt('修复失败！'),
                                content: res.message || this.$tt('修复失败'),
                                type: 'error',
                                time: 2000,
                            })
                        }
                    }).catch((error) => {
                        this.isFixingFalseFile = false
                        this.$myMsg.notify({
                            title: this.$tt('修复失败！'),
                            content: error.message || this.$tt('网络错误'),
                            type: 'error',
                            time: 2000,
                        })
                    })
                } catch (e) {
                    this.isFixingFalseFile = false
                    console.warn(e)
                }
            },
            handleFixMetadataError() {
                try {
                    this.isFixingMetadataError = true
                    this.$api.Task.queryDetailsByStatus({
                        log_id: this.id,
                        status: 'metadata_error'
                    }).then((res) => {
                        this.isFixingMetadataError = false
                        if (res.result) {
                            this.$myMsg.notify({
                                title: this.$tt('修复任务已提交！'),
                                content: this.$tt('找到 {count} 个文件，后台正在通过 FFmpeg 重新编码修复，请稍后查看审计日志', { count: res.data.count }),
                                type: 'success',
                                time: 3000,
                            })
                            // 3秒后刷新详情
                            setTimeout(() => {
                                this.$parent.fetchDetails()
                            }, 3000)
                        } else {
                            this.$myMsg.notify({
                                title: this.$tt('修复失败！'),
                                content: res.message || this.$tt('修复失败'),
                                type: 'error',
                                time: 2000,
                            })
                        }
                    }).catch((error) => {
                        this.isFixingMetadataError = false
                        this.$myMsg.notify({
                            title: this.$tt('修复失败！'),
                            content: error.message || this.$tt('网络错误'),
                            type: 'error',
                            time: 2000,
                        })
                    })
                } catch (e) {
                    this.isFixingMetadataError = false
                    console.warn(e)
                }
            }
        }
    }
</script>

<style scoped>

</style>
